module.exports = __webpack_public_path__ + "img/img-test-4.d5cabdf8.png";